module.exports = __webpack_public_path__ + "static/img/sequence-neon-min.6d1bb8b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/website/sequence-neon-min.png
// module id = 674
// module chunks = 64